module.exports = __webpack_public_path__ + "static/media/mentee_mentoring_about1.531fed78.webp";